import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-g2c-services',
    templateUrl: './g2c-services.component.html',
    styleUrls: ['./g2c-services.component.scss']
})
export class GtoCServicesComponent implements OnInit {

    @ViewChild('focusUmang')focusUmang: ElementRef;
    services: string;

    constructor(
        public router: Router
    ) { }

    ngOnInit() {
        this.services = localStorage.getItem('services');
    }

    ngAfterViewInit() {
        if (this.services == 'umang') {
            this.focusUmang.nativeElement.scrollIntoView({
                block: "center",
                behavior: "smooth",
              });
        }
    }

    ngOnDestroy() {
        localStorage.setItem('services', '');
    }

}